import { NgModule } from '@angular/core';
import { DmpSharedLibsModule } from '../../../shared-libs/shared-libs.module';
import { SelectPageHtml5Component } from './select-page-html-5.component';
import { PageHtml5Service } from './page-html-5.service';
import { LandingPagePreviewComponent } from './landing-page-preview.component';
import { LandingPageService } from './landing-page.service';


@NgModule({
  imports: [DmpSharedLibsModule],
  declarations: [
    SelectPageHtml5Component,
    LandingPagePreviewComponent
  ],
  exports:[
    SelectPageHtml5Component,
    DmpSharedLibsModule,
    LandingPagePreviewComponent
  ],
  providers: [
      PageHtml5Service,
      LandingPageService
  ]
})
export class CommonLpModule {}
